document.addEventListener('DOMContentLoaded', () => {
  const link = document.querySelector('.js-and-more-link')
  const icon = document.querySelector('.js-icon')
  const iconMore = document.querySelector('.js-icon-more')
  const symbol = document.querySelector('.js-and-more-symbol')

  link.addEventListener('click', () => {
    icon.classList.toggle('fa-plus-circle')
    icon.classList.toggle('fa-minus-circle')
  })

  // HACK: class 名を変えずに実装したいのでリファクタリング予定
  symbol.addEventListener('click', () => {
    iconMore.classList.toggle('fa-plus-circle')
    iconMore.classList.toggle('fa-minus-circle')
  })
})
